import { toKey, types } from '@tmap/mmm-core/entityKey';

const isUserModerator = (user, communityId) => {
  const moderatorRoles = ['employee', toKey(types.MODERATOR, communityId), toKey(types.OWNER, communityId)];
  return (user?.roles ?? []).some((role) => moderatorRoles.includes(role));
};

export default isUserModerator;
